<template>
  <div class="pms6002-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="4">
        <span class="iconfont icon-humidity2"></span>
        {{ $t('湿度') }}：{{ humidity }}%
      </el-col>
      <el-col tag="span" :span="4">
        <span class="iconfont icon-temperature2"></span>
        {{ $t('温度') }}：{{ temp }}℃
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    humidity: {
      type: Number,
      required: true
    },
    temp: {
      type: Number,
      requires: true
    }
  }
};
</script>

<style scoped lang="scss">
.pms6002-status-bar {
  .col-btn {
    color: #49c7c3;

    cursor: pointer;

    &:hover {
      color: #3da4a2;
      border-color: transparent;
      background-color: transparent;
    }
  }

  .iconfont {
    font-size: 20px;
    color: $normal-color;
  }

  .pump-status {
    height: 50px;
  }
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
}
</style>
